import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class DeleteDoPaymentsService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get deletable D.O payments
   * @returns Array
   */
  fetchDO_Payments(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/transactions/do-payments/deletable-list`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Delete D.O payment
   * @param row_id
   * @param vehicle_id
   */
  deleteDO_Payment(row_id:number,vehicle_id: string, chassis_no: string, amount:number){

    let apiURL:string=`${this.baseURL}/v1/transactions/do-payments/delete/${row_id}/${vehicle_id}/${chassis_no}/${amount}`;

    return this.http.delete<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
